<template>
  <div class="d-flex flex-column row-gap-6" :class="{'mt-4' : !canSeeAllVersions }" data-locator="versions-history-content">
    <template v-if="versionsLoading">
      <div class="text-center">
        <AppLoader></AppLoader>
      </div>
    </template>
    <template v-else>
      <template v-if="documentVersions && previousVersions.length === 0">
        <div>
          <p class="text--large text--bold text-text-primary">{{ $t(`${TRANSLATION_KEY_PREFIX}.noVersionTitle`) }}</p>
          <p class="text--small text--regular text-text-secondary">{{ $t(`${TRANSLATION_KEY_PREFIX}.noVersionText`) }}</p>
        </div>
        <div class="version-placeholder">
          <app-material-icon name="remove" />
        </div>
      </template>
      <template v-else-if="canSeeAllVersions">
        <p class="text--large text--bold text-text-primary">{{ $t(`${TRANSLATION_KEY_PREFIX}.currentVersionTitle`) }}</p>
        <DocumentVersioningHistoryItem :item="currentVersion"
                                       :no-share="noShare"
                                       @share-version="onShareVersion"
        />
        <v-divider></v-divider>
        <p class="text--large text--bold text-text-primary">{{ $t(`${TRANSLATION_KEY_PREFIX}.previousVersionsTitle`) }}</p>
        <DocumentVersioningHistoryItem v-for="item in previousVersions"
                                       :key="item.id"
                                       :item="item"
                                       deletable
                                       :no-share="noShare"
                                       @delete-version="onDeleteVersion"
                                       @share-version="onShareVersion"
        />
      </template>
      <template v-else>
        <p class="text--small text--regular text-text-secondary">{{ $t(`${TRANSLATION_KEY_PREFIX}.guestText`) }}</p>
        <DocumentVersioningHistoryItem v-for="item in documentVersions"
                                       :key="item.id"
                                       :item="item"
                                       :no-share="noShare"
                                       @delete-version="onDeleteVersion"
                                       @share-version="onShareVersion"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import AppLoader from '@/common/AppLoader.vue'
import { toast } from '@/common/utils/toast'
import { DELETE_VERSION, GET_DOCUMENT_VERSIONS } from '@/store/modules/documents/action_types'

import DocumentVersioningHistoryItem from './DocumentVersioningHistoryItem.vue'

const TRANSLATION_KEY_PREFIX = 'common.document-versioning.DocumentVersioningHistory'

export default {
  name: 'DocumentVersioningHistory',
  components: {
    AppLoader,
    DocumentVersioningHistoryItem,
  },
  emits: ['share-version'],
  props: {
    noShare: {
      type: Boolean,
      default: false,
    },
    selectedDocuments: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      TRANSLATION_KEY_PREFIX,
      documentVersions: [],
    }
  },
  watch: {
    selectedDocuments: {
      handler () {
        this.prepareGetDocumentVersions()
      },
    },
  },
  methods: {
    ...mapActions('documents', [DELETE_VERSION, GET_DOCUMENT_VERSIONS]),
    async prepareGetDocumentVersions () {
      try {
        const response = await this.GET_DOCUMENT_VERSIONS({
          mnemo: this.roomMnemo,
          documentId: this.selectedDocuments[0].id,
        })
        this.documentVersions = response.data
      } catch (error) {
        console.error(error)
      }
    },
    async onDeleteVersion (data) {
      try {
        await this.DELETE_VERSION(data)
        this.prepareGetDocumentVersions()
      } catch (e) {
        toast.error(this.$t(`${TRANSLATION_KEY_PREFIX}.deleteVersionError`))
      }
    },
    onShareVersion (data) {
      this.$emit('share-version', data)
    },
  },
  computed: {
    ...mapState('documents', ['versionsLoading']),
    ...mapGetters('room', ['isCurrentUserPm', 'currentUserRights', 'roomMnemo', 'isDataRoom']),
    canSeeAllVersions () {
      return this.isCurrentUserPm || this.currentUserRights?.canUploadVersions
    },
    currentVersion () {
      return this.documentVersions[0]
    },
    previousVersions () {
      return this.documentVersions.slice(1)
    },
  },
  created () {
    this.prepareGetDocumentVersions()
  },
}
</script>

<style lang="scss" scoped>
.version-placeholder {
  border: 1px solid rgb(var(--v-theme-border-primary));
  background-color: rgb(var(--v-theme-surface-secondary));
  border-radius: 8px;
  display: grid;
  min-height: 72px;
  padding: 8px 16px;
  place-items: center;
}
</style>
